export const DEFAULT_SESSION_TIMEOUT = 2 * 60 * 60; // 2 hours
export const DEFAULT_SESSION_TIMEOUT_WARNING = 5; // 5 seconds
